// 注意！ 这个文件只是为了方便管理
// 其他业务要获取 token 统一使用本目录下 index.js 内的方法

const id = "token";
export function set(val) {
    localStorage.setItem(id, val);
}
export function get() {
    return localStorage.getItem(id);
}
export function clear() {
    localStorage.removeItem(id);
}
